import { LobbyCheckIn } from "./../../lobby/shared/models/lobby-check-in";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { GridDataResult, PageChangeEvent } from "@progress/kendo-angular-grid";
import { SortDescriptor } from "@progress/kendo-data-query";
import { Observable, Subscription } from "rxjs";
import {
  AppointmentStatus,
  AppointmentStatusGridData,
} from "./shared/models/AppointmentStatusGridData";
import {
  getAppointmentStatusGridData,
  getAppointmentStatusGridFilters,
  getAppointmentStatusSearchFilter,
  State,
} from "./state";
import * as AppointmentStatusGridActions from "./state/actions/appointment-status-grid.actions";
import {
  getLobbyLocationSelected,
  getCurrentLocationTimeZone,
  getCurrentTenant,
  getLoggedInUserId,
  GetUserPermissionList,
  getSignedInStatus,
  getLobbyLocationSelctorStatus,
  getLoggedInUserInfo,
} from "src/app/state";
import { LocationSelectorInfo } from "src/app/admin/user/shared/models/locationSelectorModel";
import * as CoreActions from "src/app/state/actions/core.actions";
import { UserSigninStatusModel } from "src/app/lobby/shared/models/lobby-user-signin-status.model";
import { UserSigninStatus } from "src/app/shared/enums/UserSigninStatus.enum";
import { SessionService } from "src/app/shared/services/session.service";
import { ToastService } from "src/app/shared/services/toast.service";
import { LobbyService } from "src/app/lobby/shared/services/lobby.service";
import { take } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment-timezone";

@Component({
  selector: "app-appointment-status-grid",
  templateUrl: "./appointment-status-grid.component.html",
  styleUrls: ["./appointment-status-grid.component.scss"],
})
export class AppointmentStatusGridComponent implements OnInit, OnDestroy {
  sort: SortDescriptor[] = [
    {
      field: "appointmentTime",
      dir: "asc",
    },
  ];
  searchFilter = "";
  selectedAppointmentRecord: AppointmentStatus = <AppointmentStatus>{};
  openProductServiceDialog = false;
  openCheckInConfirmationDialog = false;
  openNoShowConfirmationDialog = false;

  public tenantId: number = 0;
  public locationId = 0;
  public userId = 0;
  public locationTimeOffset = "+0000";
  public selectedLocationName: string = "";
  public locationTimezoneId: string = "Sri Lanka Standard Time";
  appointmentGridSubscriptions = new Subscription();
  public IsSignedIn: boolean = false;
  gridData$: Observable<AppointmentStatusGridData> =
    new Observable<AppointmentStatusGridData>();
  public userPermissionList: number[] = [];
  public disableSelector: boolean = false;
  public selectorHoverMessage: string = "";
  disableSelectorNoBranch: boolean = false;
  prefferedTzCode: string = "";
  lobbyLocationTzName: string = "";
  gridFilters: any = [];
  public gridView: GridDataResult = { data: [], total: 0 };
  public pageSize: number = 0;
  public skip: number = 0;
  checkinInfo1Text: string = "";
  checkinInfo2Text: string = "";
  markInfo1Text: string = "";
  markInfo2Text: string = "";

  constructor(
    private store: Store<State>,
    private session: SessionService,
    public toastService: ToastService,
    public lobbyService: LobbyService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.store.select(GetUserPermissionList).subscribe((allUserPermissions) => {
      if (!allUserPermissions) {
        throw Error("allUserPermissions is undefined!");
      }
      this.userPermissionList = allUserPermissions;
    });

    const gridDataSubscription = this.store
      .select(getAppointmentStatusGridData)
      .subscribe((gridData) => {
        this.gridView = {
          data: gridData.data ?? [],
          total: gridData.totalRowCount ?? 0,
        };
        this.pageSize = gridData.pageSize ?? 1;
        this.skip = (gridData.currentPageNumber - 1) * this.pageSize;
      });
    this.store.select(getAppointmentStatusSearchFilter);
    this.store.dispatch(
      AppointmentStatusGridActions.setSubscribeToAppointmentStatusGrid()
    );

    const gridFilterSubscription = this.store
      .select(getAppointmentStatusGridFilters)
      .subscribe((gridFilters) => {
        if (
          gridFilters !== null &&
          gridFilters.LocationId &&
          gridFilters.LocationId > 0
        ) {
          this.gridFilters = gridFilters;
        }
      });
    const SearchFilterSubscription = this.store
      .select(getAppointmentStatusSearchFilter)
      .subscribe((searchFilters) => {
        this.searchFilter = searchFilters;
      });

    const signinStatusSubscription = this.store
      .select(getSignedInStatus)
      .subscribe((status: any) => {
        this._onUserSignedInStatusUpdated(status);
      });
    this.SetAcLocationState();
    const locationSub = this.store
      .select(getLobbyLocationSelected)
      .subscribe((location) => {
        if (location.locationId !== undefined && location.locationId !== null) {
          this.locationId = location.locationId;
          this.selectedLocationName = location.locationName;
          this.disableSelectorNoBranch = location.dropDownDisabled;
          this.lobbyLocationTzName = location.timeZoneName;
          this.locationTimezoneId = location.timezoneId;
          if (
            this.lobbyLocationTzName != undefined &&
            this.lobbyLocationTzName != ""
          ) {
            this.setInitialDateRange();
          }
          this.store.dispatch(
            AppointmentStatusGridActions.setAppointmentStatusGridLocation({
              locationId: this.locationId,
            })
          );
        }
      });

    const locationSelectorStatusSubscription = this.store
      .select(getLobbyLocationSelctorStatus)
      .subscribe((status) => {
        if (status != undefined) {
          if (this.IsSignedIn && status.isError) {
            this.disableSelector = true;
            if (
              status.errorMessage.includes(
                "_Lobby_Cannot_Change_Single_Requested_Notification_Group_Error_Text_"
              )
            ) {
              const groupName = status.errorMessage.split("groups:")[1];
              this.selectorHoverMessage = this.translateService.instant(
                "_Lobby_Cannot_Change_Single_Requested_Notification_Group_Error_Text_",
                { value0: groupName }
              );
            } else if (
              status.errorMessage.includes(
                "_Lobby_Cannot_Change_Many_Requested_Notification_Groups_Error_Text_"
              )
            ) {
              const allGroupsAsOne = status.errorMessage.split("groups:")[1];
              const groups = allGroupsAsOne.split(",").map((g) => g.trim());
              const allButLast = groups.slice(0, -1).join(", ");
              const lastGroup = groups[groups.length - 1];
              this.selectorHoverMessage = this.translateService.instant(
                "_Lobby_Cannot_Change_Many_Requested_Notification_Groups_Error_Text_",
                { value0: allButLast, value1: lastGroup }
              );
            } else {
              this.selectorHoverMessage = status.errorMessage;
            }
          } else if (!this.disableSelectorNoBranch) {
            this.disableSelector = false;
            this.selectorHoverMessage = "";
          }
        }
      });
    const uerSignInSubscription = this.store
      .select(getLoggedInUserInfo)
      .subscribe((loggedInUserInfo) => {
        if (
          loggedInUserInfo != null &&
          loggedInUserInfo != undefined &&
          loggedInUserInfo.homeLocationId != undefined
        ) {
          this.prefferedTzCode = loggedInUserInfo.prefferedTimeZone.tzCode;
        }
      });
    this.appointmentGridSubscriptions.add(gridDataSubscription);
    this.appointmentGridSubscriptions.add(signinStatusSubscription);
    this.appointmentGridSubscriptions.add(locationSelectorStatusSubscription);
    this.appointmentGridSubscriptions.add(gridFilterSubscription);
    this.appointmentGridSubscriptions.add(SearchFilterSubscription);
    this.appointmentGridSubscriptions.add(locationSub);
    this.appointmentGridSubscriptions.add(uerSignInSubscription);

    this.subscribeToCurrentStateInfo();

    this.store.dispatch(
      AppointmentStatusGridActions.setAppointmentStatusGridLocation({
        locationId: this.locationId,
      })
    );
    this.store.dispatch(
      AppointmentStatusGridActions.subscribeToAppointmentStatusGridData({
        appointmentStatusGridFilter: this.gridFilters,
      })
    );

    this.translateService
      .get([
        "_Appointment_Status_Grid_Checkin_Info1_Text_",
        "_Appointment_Status_Grid_Checkin_Info2_Text_",
        "_Appointment_Status_Grid_Mark_Info1_Text_",
        "_Appointment_Status_Grid_Mark_Info2_Text_",
      ])
      .subscribe((translation) => {
        this.checkinInfo1Text =
          translation["_Appointment_Status_Grid_Checkin_Info1_Text_"];
        this.checkinInfo2Text =
          translation["_Appointment_Status_Grid_Checkin_Info2_Text_"];
        this.markInfo1Text =
          translation["_Appointment_Status_Grid_Mark_Info1_Text_"];
        this.markInfo2Text =
          translation["_Appointment_Status_Grid_Mark_Info2_Text_"];
      });
  }

  private _onUserSignedInStatusUpdated(status: UserSigninStatusModel): void {
    if (
      status &&
      (status.statusId === UserSigninStatus.Idle ||
        status.statusId === UserSigninStatus.Assisting)
    ) {
      this.IsSignedIn = true;
    } else {
      this.IsSignedIn = false;
    }
  }

  private SetAcLocationState() {
    //Set signed in users home location as the default location when loading the location grid
    const locationACCodeSubscription = this.store
      .select(getLobbyLocationSelected)
      .pipe(take(1))
      .subscribe((location) => {
        if (
          location.locationCode !== undefined &&
          location.locationCode !== null
        ) {
          this.store.dispatch(
            CoreActions.updateACLocationSelectorInfo({
              payload: { acLocationCode: location.locationCode },
            })
          );
        }
      });

    this.appointmentGridSubscriptions.add(locationACCodeSubscription);
  }
  private _ShowUserSigninPrompt(): void {
    this.store.dispatch(
      CoreActions.promptUserToSignin({ payload: { isSelectorChange: true } })
    );
  }
  private setSessionData(locaitonSelectorData: LocationSelectorInfo) {
    this.locationTimezoneId = locaitonSelectorData.timezoneId;
    this.lobbyLocationTzName = locaitonSelectorData.timeZoneName;
    if (
      this.lobbyLocationTzName != undefined &&
      this.lobbyLocationTzName != ""
    ) {
      this.setInitialDateRange();
    }
    this.session.clearLobbyLocation();
    this.session.clearSignInSession();
    this.lobbyService.changeLocationChangeFlag(true);
    this.session.setLobbyLocation(locaitonSelectorData);
    this.session.setSignInStatus({
      userId: this.userId,
      locationId: locaitonSelectorData.id ?? 0,
      statusId: null,
      status: null,
      statusReason: null,
      currentAssistingLobbyEntryId: null,
      locationCode: "",
      currentAssistingLocationId: null,
      impersonateById: null,
      impersonateByName: null,
      isImpersonateOtherUser: false,
      impersonationTransferDetails: null,
    });
    this.store.dispatch(
      CoreActions.updateLobbyLocationSelectorInfo({
        payload: { lobbyLocationSelectorInfo: locaitonSelectorData },
      })
    );
    this.store.dispatch(
      CoreActions.updateACLocationSelectorInfo({
        payload: { acLocationCode: locaitonSelectorData.locationCode },
      })
    );
    this.store.dispatch(
      AppointmentStatusGridActions.setAppointmentStatusGridLocation({
        locationId: this.locationId,
      })
    );
    this.store.dispatch(
      AppointmentStatusGridActions.setAppointmentStatusGridPagination({
        page: 1,
        pageSize: this.pageSize,
      })
    );
    this.store.dispatch(
      AppointmentStatusGridActions.subscribeToAppointmentStatusGridData({
        appointmentStatusGridFilter: this.gridFilters,
      })
    );
  }
  public handleLocationData(locaitonSelectorData: LocationSelectorInfo): void {
    if (!this.IsSignedIn) {
      this._ShowUserSigninPrompt();
      this.setSessionData(locaitonSelectorData);
    } else {
      this.lobbyService
        .changeSignInBranch({
          userId: this.userId,
          locationId: locaitonSelectorData.id ?? 0,
          branchId: this.locationId,
        })
        .subscribe({
          next: () => {
            this.setSessionData(locaitonSelectorData);
            this.store.dispatch(
              CoreActions.loadSignInDetailsForUser({
                payload: {
                  userId: this.userId,
                  tenantId: this.tenantId,
                  locationId: locaitonSelectorData.id ?? 0,
                },
              })
            );
            const translatedToastMsg = this.translateService.instant(
              "_General_Signed_Into_Ts_Text_"
            );
            this.toastService.showSuccess(
              translatedToastMsg + " " + locaitonSelectorData.locationName
            );
          },
          error: () => {
            this.toastService.showError(
              "_General_Changing_Signed_Location_Failed_Ts_Text_"
            );
          },
        });
    }
  }

  public pageChange(event: PageChangeEvent): void {
    const page = event.skip / event.take + 1;
    this.store.dispatch(
      AppointmentStatusGridActions.setAppointmentStatusGridPagination({
        page,
        pageSize: event.take,
      })
    );
    this.store.dispatch(
      AppointmentStatusGridActions.subscribeToAppointmentStatusGridData({
        appointmentStatusGridFilter: this.gridFilters,
      })
    );
  }

  sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    let field = "";
    switch (sort[0].field) {
      case "appointmentTime":
        field = "AppointmentTime";
        break;
      case "appointmentTypeId":
        field = "AppointmentTypeId";
        break;
      case "confirmationNumber":
        field = "ConfirmationNumber";
        break;
      case "firstName":
        field = "FirstName";
        break;
      case "lastName":
        field = "LastName";
        break;
      case "appointmentServiceRequests":
        field = "AppointmentServiceRequests";
        break;
      case "notes":
        field = "Notes";
        break;
      case "status":
        field = "Status";
        break;
      case "personRequested":
        field = "PersonRequested";
        break;
    }
    this.store.dispatch(
      AppointmentStatusGridActions.setAppointmentStatusGridSortOptions({
        sortColumn: field,
        sortDirection: sort[0].dir!,
      })
    );
    this.store.dispatch(
      AppointmentStatusGridActions.subscribeToAppointmentStatusGridData({
        appointmentStatusGridFilter: this.gridFilters,
      })
    );
  }

  serviceRequestedExpandHandler(dataItem: AppointmentStatus) {
    this.selectedAppointmentRecord = dataItem;
    this.openProductServiceDialog = true;
  }

  closeProductServiceDialog() {
    this.selectedAppointmentRecord = <AppointmentStatus>{};
    this.openProductServiceDialog = false;
  }

  removeSearchFilter() {
    this.searchFilter = "";
    this.store.dispatch(
      AppointmentStatusGridActions.removeAppointmentStatusGridSearchFilter()
    );
    this.store.dispatch(
      AppointmentStatusGridActions.setAppointmentStatusGridPagination({
        page: 1,
        pageSize: this.pageSize,
      })
    );
    this.store.dispatch(
      AppointmentStatusGridActions.subscribeToAppointmentStatusGridData({
        appointmentStatusGridFilter: this.gridFilters,
      })
    );
  }

  setSearchFilter() {
    this.store.dispatch(
      AppointmentStatusGridActions.setAppointmentStatusGridSearchFilter({
        searchFilter: this.searchFilter,
      })
    );
    this.store.dispatch(
      AppointmentStatusGridActions.setAppointmentStatusGridPagination({
        page: 1,
        pageSize: this.pageSize,
      })
    );
    this.store.dispatch(
      AppointmentStatusGridActions.subscribeToAppointmentStatusGridData({
        appointmentStatusGridFilter: this.gridFilters,
      })
    );
  }

  setInitialDateRange() {
    const date = new Date();
    const todayFrom = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    );
    date.setDate(date.getDate() + 1);
    const todayTo = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    );
    this.store.dispatch(
      AppointmentStatusGridActions.setAppointmentStatusFromDate({
        fromDate: this.getUtCTimeBasedOnUserPrefferedTimeZone(todayFrom),
        toDate: this.getUtCTimeBasedOnUserPrefferedTimeZone(todayTo),
      })
    );
  }
  getUtCTimeBasedOnUserPrefferedTimeZone(date: Date) {
    //passed the current date and time
    const tZone = this.lobbyLocationTzName;
    var timeZonedate = this.convertLocalToTimezone(
      date.toLocaleString(),
      undefined,
      tZone
    ); //get the curret date for that time zone
    var input = this.formatDate(timeZonedate) + " 12:00:00 AM"; //add 12:00 AM for that time
    var fmt = "YYYY-MM-DD h:mm:ss A";
    return moment.tz(input, fmt, tZone).utc().format(fmt); //convert the date to utc time
  }
  // convert local time to another timezone
  convertLocalToTimezone(
    localDt: string,
    localDtFormat: string | undefined,
    timezone: string
  ) {
    return moment(localDt, localDtFormat)
      .tz(timezone)
      .format("YYYY-MM-DD hh:mm:ss A");
  }

  formatDate(date: string) {
    //need to move this to  common place
    var d = new Date(Date.parse(date.replace(/-/g, " "))),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  showCheckInConfirmation(dataItem: AppointmentStatus) {
    this.selectedAppointmentRecord = dataItem;
    this.openCheckInConfirmationDialog = true;
  }

  showNoShowConfirmation(dataItem: AppointmentStatus) {
    this.selectedAppointmentRecord = dataItem;
    this.openNoShowConfirmationDialog = true;
  }

  checkInAppointmentToLobby(dataItem: AppointmentStatus, timeZoneId: string) {
    const checkIn: LobbyCheckIn = {
      LocationId: this.locationId,
      LobbySourceId: 1,
      TimeZoneId: timeZoneId,
      AccountNumber: "",
      FirstName: dataItem.firstName,
      LastName: dataItem.lastName,
      DateOfBirth: "",
      Notes: dataItem.notes,
      PhoneNumber: dataItem.phoneNumber,
      EmailAddress: dataItem.email,
      PreferredLanguage: dataItem.spanishSpeakerRequested ? 3 : 1,
      RecieveTextMessage: dataItem.recieveTextMessage,
      AddedBy: this.userId,
      ServiceRequested: dataItem.appointmentServiceRequestsIds,
      CustomFieldValues: {},
      AppointmentId: dataItem.appointmentId,
      UserRequested: dataItem.personRequestedId,
      GroupRequested: null,
      LobbyId: null,
      lobbyEntryId: -1,
    };
    this.store.dispatch(
      AppointmentStatusGridActions.checkInAppointmentToLobby({
        lobbyCheckIn: checkIn,
      })
    );
  }

  updateAppointmentStatusToNoShow(dataItem: AppointmentStatus) {
    this.store.dispatch(
      AppointmentStatusGridActions.updateAppointmentStatusToNoShow({
        confirmationNumber: dataItem.confirmationNumber,
      })
    );
  }

  closeCheckInConfirmationDialog(action: string) {
    if (action === "yes") {
      this.checkInAppointmentToLobby(
        this.selectedAppointmentRecord,
        this.locationTimezoneId
      );
    }

    this.selectedAppointmentRecord = <AppointmentStatus>{};
    this.openCheckInConfirmationDialog = false;
  }

  closeNoShowConfirmationDialog(action: string) {
    if (action === "yes") {
      this.updateAppointmentStatusToNoShow(this.selectedAppointmentRecord);
    }

    this.selectedAppointmentRecord = <AppointmentStatus>{};
    this.openNoShowConfirmationDialog = false;
  }

  editACAppointmet(dataItem: AppointmentStatus) {
    this.store.dispatch(
      AppointmentStatusGridActions.routeToAppointmentWidget({
        confirmationNumber: dataItem.confirmationNumber,
      })
    );
  }

  /**
   *  Subscribe to the state information on the current session
   */
  public subscribeToCurrentStateInfo() {
    const tenantSelectionSub = this.store
      .select(getCurrentTenant)
      .subscribe((tenant) => {
        if (tenant) {
          this.tenantId = tenant.tenantID;
          this.store.dispatch(
            AppointmentStatusGridActions.setAppointmentStatusGridTenantId({
              tenantId: this.tenantId,
            })
          );
        }
      });

    const timezoneOffsetSub = this.store
      .select(getCurrentLocationTimeZone)
      .subscribe((offset) => {
        if (offset !== undefined && offset !== null) {
          this.locationTimeOffset = offset.toString();
        }
      });
    const loggedUserSub = this.store
      .select(getLoggedInUserId)
      .subscribe((userId) => {
        if (userId !== undefined && userId !== null) {
          this.userId = userId;
        }
      });
    this.appointmentGridSubscriptions.add(tenantSelectionSub);

    this.appointmentGridSubscriptions.add(timezoneOffsetSub);
    this.appointmentGridSubscriptions.add(loggedUserSub);
  }

  /**
   * Destroy the subscriptions.
   */
  ngOnDestroy(): void {
    this.appointmentGridSubscriptions.unsubscribe();
    const groupNames = ["AppointmentGridGroup"];
    this.store.dispatch(
      CoreActions.unsubscribeFromSignalRGroups({ groupNames })
    );
  }
}
